import { render, staticRenderFns } from "./wikiLoading.vue?vue&type=template&id=2b8aae16"
import script from "./wikiLoading.vue?vue&type=script&lang=js"
export * from "./wikiLoading.vue?vue&type=script&lang=js"
import style0 from "./wikiLoading.vue?vue&type=style&index=0&id=2b8aae16&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports